export default __webpack_public_path__ + "static/media/EBU-4.b0801bff.jpg";